// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"3eec3a6b","80":"0bb3c6b8","151":"7be434b1","180":"03647b3c","290":"d249252e","346":"c48a9f32","417":"489cacdf","453":"c5a6b037","460":"ad3f27af","662":"3597a815","667":"0bc3b792","687":"d647f95c","841":"4c280778","845":"e42061dd","974":"43a21136"}[chunkId] + ".chunk.js";
};